import {computed, Injectable, signal} from '@angular/core';
import {CashTransaction} from '../../../domain/value-objects/cash-transaction';
import {CashAmountInput} from '../../../domain/value-objects/cash-amount-input';

export interface CashKeyboardVM {
  totalToPay: string;
  deliveredAmount: string;
  change: string;
  isValid: boolean;
  isTotalExact: boolean;
}

@Injectable()
export class CashKeyboardPresenter {
  private readonly amountToPay = signal<number>(0);
  private readonly amountInput = signal<CashAmountInput>(CashAmountInput.empty());

  readonly viewModel = computed<CashKeyboardVM>(() => {
    const total = this.amountToPay();
    const input = this.amountInput();
    
    const transaction = CashTransaction.create(total, input.amount);

    return {
      totalToPay: this.formatCurrency(total),
      deliveredAmount: input.displayValue,
      change: this.formatCurrency(transaction.change),
      isValid: transaction.isValid,
      isTotalExact: transaction.change === 0 && input.amount > 0
    };
  });

  init(total: number): void {
    this.amountToPay.set(total);
    this.amountInput.set(CashAmountInput.empty());
  }

  appendDigit(digit: number): void {
    this.amountInput.update(input => input.append(digit.toString()));
  }

  deleteLastDigit(): void {
    this.amountInput.update(input => input.removeLast());
  }

  appendDecimalSeparator(): void {
    this.amountInput.update(input => input.appendComma());
  }

  getDeliveredAmount(): number {
    return this.amountInput().amount;
  }

  private formatCurrency(value: number): string {
    return value.toLocaleString('es-ES', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
}
